import React from 'react'

const handleGeneralError = (e, args) => {
  if (e?.response?.status === 500)
    args.dispatch(
      args.showToast({
        title: e?.response?.data?.status,
        message: e?.response?.data?.error?.message,
        color: 'danger',
      }),
    )
  else if (e?.response?.status === 404 && e?.response?.data?.error?.message == null)
    args.dispatch(
      args.showToast({
        title: 'Something Went Wrong',
        message: 'Please try again later',
        color: 'danger',
      }),
    )
  else if (e.response.data.displayMessage === 'Country not found')
    args.dispatch(
      args.showToast({
        title: 'No country selected',
        message: 'As a super admin please select a country',
        color: 'warning',
      }),
    )
  else if (e.response.data.statusCode === 409 || e.response.data.statusCode === 400)
    args.dispatch(
      args.showToast({
        title: e.response.data.statusMessage,
        message: e.response.data.displayMessage,
        color: 'danger',
      }),
    )
  else
    args.dispatch(
      args.showToast({
        title: e.response.data.displayMessage,
        message: e.response.data.error?.map((e) => <p key={e.message}>{e.message}</p>),
        color: 'danger',
      }),
    )
}

export default handleGeneralError
